import React, { Component } from "react";
import Login from "./layouts/LoginForm";
import StudioChoice from "./layouts/StudioChoice";
import CheckIn from "./layouts/CheckIn";
import { reactLocalStorage } from "reactjs-localstorage";
import "./App.css";

class App extends Component {
	constructor(props) {
		super(props);
		this.state = {
			screen: "login"
		};

		const authToken = reactLocalStorage.get("authToken", false);
		const club = reactLocalStorage.get("club", false);
		const resource = reactLocalStorage.get("resource", false);
		if (authToken && (!club || !resource)) {
			this.state.screen = "studioChoice";
		} else if ( authToken && club && resource ) {
			this.state.screen = "checkin";
		}

		this.handleNav = this.handleNav.bind(this);
	}
	handleNav(screen) {
		this.setState({ screen: screen });
	}
	render() {
		let displayScreen;
		switch (this.state.screen) {
		case "studioChoice":
			displayScreen = <StudioChoice handleNav={this.handleNav} />;
			break;
		case "checkin":
			displayScreen = <CheckIn handleNav={this.handleNav} />;
			break;
		default:
			displayScreen = <Login handleNav={this.handleNav} />;
		}

		return <div className="App">{displayScreen}<div className="version">v1.0.3</div></div>;
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js